export default "__VITE_ASSET__UbWhYbvs__"